module.exports = __webpack_public_path__ + "static/media/landline.503baf6d.png";